import React from 'react'
import styled, { css } from 'styled-components'
import FinanceCardHeader from './FinanceCardHeader'
import { financeColors, financeRadius } from '../tokens'
import { FinanceCardTone } from '../types'

interface Props {
  title?: React.ReactNode
  description?: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  tone?: FinanceCardTone
  padding?: 'md' | 'lg'
  bordered?: boolean
}

const toneStyles = {
  default: css`
    background: ${financeColors.surface};
    border-color: ${financeColors.border};
  `,
  info: css`
    background: ${financeColors.surfaceInfo};
    border-color: ${financeColors.infoBorder};
  `,
  success: css`
    background: ${financeColors.successBg};
    border-color: ${financeColors.successBorder};
  `,
  warning: css`
    background: ${financeColors.warningBg};
    border-color: ${financeColors.warningBorder};
  `,
  danger: css`
    background: ${financeColors.dangerBg};
    border-color: ${financeColors.dangerBorder};
  `,
}

const Wrap = styled.div<{
  $tone: FinanceCardTone
  $padding: 'md' | 'lg'
  $bordered: boolean
}>`
  border: 1px solid transparent;
  border-radius: ${financeRadius.lg};
  padding: ${(props) => (props.$padding === 'lg' ? '20px' : '16px')};
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
  ${(props) => toneStyles[props.$tone]};
  ${(props) => !props.$bordered && 'border-color: transparent;'}
`

const FinanceCard: React.FC<Props> = ({
  title,
  description,
  actions,
  children,
  tone = 'default',
  padding = 'lg',
  bordered = true,
}) => {
  return (
    <Wrap $tone={tone} $padding={padding} $bordered={bordered}>
      <FinanceCardHeader
        title={title}
        description={description}
        actions={actions}
      />
      {children}
    </Wrap>
  )
}

export default FinanceCard
